<template>
    <div name="card-input" class="input">
        <span class="title">카드 정보를 입력해 주세요</span>
        <span class="title" style="margin-top: -20px; font-weight: 400;">하나카드는 현재 지원하지 않습니다. 다른 카드사를 이용해주세요.</span>
        <span class="label">카드 번호</span>
        <div class="card-box">
            <input v-model="cardN1" ref="input1" class="card-number" /><span class="bar-style">-</span>
            <input v-model="cardN2" ref="input2" class="card-number" type="password" /><span class="bar-style">-</span>
            <input v-model="cardN3" ref="input3" class="card-number" type="password" /><span class="bar-style">-</span>
            <input v-model="cardN4" ref="input4" class="card-number" />
        </div>        
        <span class="label">유효기간</span>            
        <input class="full-input" v-model="card_ex" placeholder="MMYY"/>  
        <span class="label">비밀번호 앞 2자리</span>
        <input class="full-input" v-model="card_pw" type="password" placeholder="**"/>   
        <span class="label">이름 (카드 소유자)</span>
        <input class="full-input" v-model="card_user_name" placeholder="이름을 적어주세요." /> 
        <span class="label">카드 별명</span> 
        <input class="full-input" v-model="card_nick_name" placeholder="별명을 적어주세요."/>     
        <span class="label">생년월일</span>
        <input class="full-input" v-model="card_user_birth" placeholder="6자리"/>
        <!-- <button class="button" @click="updateCard" v-if="card_index !== -1">등록</button> -->
        <button class="button" @click="addCard">등록</button>
    </div>
</template>

<script>
import Constant from '@/constant';
import {mapState} from 'vuex';
// add, update
// close, add, update (정보 제공)
// keypad 숫자만
export default {
    name: 'cardInput',
    props: ['card_index', 'user_id', 'reception_number'],
    computed: mapState(['card']),
    data: function()
    {
        return {
            cardN1: '',
            cardN2: '',
            cardN3: '',
            cardN4: '',
            card_number: '',
            card_ex: '',
            card_ex_month: '',
            card_ex_year: '',
            card_pw: '',
            card_user_name: '',
            card_nick_name: '',
            card_user_birth: ''
        }
    },
    mounted: function()
    {
        if(this.card_index === -1)
        {
            //init 
            
        }
        else
        {
            // update 
        }
    },
    methods: {
        addCard: function()
        {
            // 카드번호 16자리, 15자리 
            // 생년월일 6자리 10자리 
            // 비밀번호 2자리
            if(!this.isNumber(this.cardN1) || !this.isNumber(this.cardN2) || !this.isNumber(this.cardN3) || !this.isNumber(this.cardN4))
            {
                alert("카드 번호는 숫자만 입력해주세요.")
                return;
            }

            if(!this.isNumber(this.card_ex))
            {
                alert("카드 유효기간은 숫자만 입력해주세요.")
                return;
            }

            if(!this.isNumber(this.card_pw))
            {
                alert("카드 비밀번호는 숫자만 입력해주세요.")
                return;
            }

            if(!this.isNumber(this.card_user_birth))
            {
                alert("생년월일/사업자번호는 숫자만 입력해주세요.")
                return;
            }

            if(this.cardN1.length === 4 && this.cardN2.length === 4 && this.cardN3.length === 4 && (this.cardN4.length === 4 ||this.cardN4.length === 3))
            {
                this.card_number = `${this.cardN1}${this.cardN2}${this.cardN3}${this.cardN4}`;
            }
            else
            {               
                alert("카드번호를 확인해주세요")
                return;
            }
            
            if(this.card_ex.length === 4)
            {
                this.card_ex_month = this.card_ex.substring(0, 2);
                this.card_ex_year = this.card_ex.substring(2, 4);
            }
            else
            {
                alert("유효기간을 확인해주세요")
                return;
            }

            if(this.card_pw.length !== 2)
            {
                alert("비밀번호를 확인해주세요")
                return;
            }

            if(this.card_nick_name === '')
            {
                alert("카드별명을 확인해주세요")
                return;
            }

            if(this.card_user_name === '')
            {
                alert("이름을 확인해주세요")
                return;
            }

            if(this.card_user_birth.length !== 6 && this.card_user_birth.length !== 10)
            {
                alert("생년월일/사업자번호를 확인해주세요")
                return;
            }

            //card_number: this.card_number, card_pw: this.card_pw, card_ex_month: this.card_ex_month, card_ex_year: this.card_ex_year, card_nick_name: this.card_nick_name, card_user_name: this.card_user_name, card_user_birth: this.card_user_birth, user_id: this.user_id
            this.$store.commit(Constant.INITIALIZE_CARD_INFO)

            

            this.card.receptionNumber = this.$route.query.reception_number
            this.card.cardNumber = this.card_number,
            this.card.cardPw = this.card_pw,
            this.card.cardExMonth = this.card_ex_month,
            this.card.cardExYear = this.card_ex_year,
            this.card.cardNickName = this.card_nick_name,
            this.card.cardUserName = this.card_user_name, 
            this.card.cardUserBirth = this.card_user_birth

            // add card
            this.$store.dispatch(Constant.FORCE_CARD_CREATED)
                .then((res) => {
                    alert("등록이 완료되었습니다.")
                    this.$store.commit(Constant.INITIALIZE_CARD_INFO)
                    this.card_number = "";
                    this.card_pw = "";
                    this.card_ex_month = "";
                    this.card_ex_year = "";
                    this.card_nick_name = "";
                    this.card_user_name = "";
                    this.card_user_birth = "";

                    this.cardN1 = ''
                    this.cardN2 = ''
                    this.cardN3 = ''
                    this.cardN4 = ''
                })
                .catch((err) => {
                    alert(err)
                })

        },
        updateCard: function()
        {
            // update card
            // 카드번호 16자리, 15자리 
            // 생년월일 6자리 10자리 
            // 비밀번호 2자리
            if(!this.isNumber(this.cardN1) || !this.isNumber(this.cardN2) || !this.isNumber(this.cardN3) || !this.isNumber(this.cardN4))
            {
                alert("카드 번호는 숫자만 입력해주세요.")
                return;
            }

            if(!this.isNumber(this.card_ex))
            {
                alert("카드 유효기간은 숫자만 입력해주세요.")
                return;
            }

            if(!this.isNumber(this.card_pw))
            {
                alert("카드 비밀번호는 숫자만 입력해주세요.")
                return;
            }

            if(!this.isNumber(this.card_user_birth))
            {
                alert("생년월일/사업자번호는 숫자만 입력해주세요.")
                return;
            }

            if(this.cardN1.length === 4 && this.cardN2.length === 4 && this.cardN3.length === 4 && (this.cardN4.length === 4 ||this.cardN4.length === 3))
            {
                this.card_number = `${this.cardN1}${this.cardN2}${this.cardN3}${this.cardN4}`;
            }
            else
            {               
                alert("카드번호를 확인해주세요")
                return;
            }
            
            if(this.card_ex.length === 4)
            {
                this.card_ex_month = this.card_ex.substring(0, 2);
                this.card_ex_year = this.card_ex.substring(2, 4);
            }
            else
            {
                alert("유효기간을 확인해주세요")
                return;
            }

            if(this.card_pw.length !== 2)
            {
                alert("비밀번호를 확인해주세요")
                return;
            }

            if(this.card_nick_name === '')
            {
                alert("카드별명을 확인해주세요")
                return;
            }

            if(this.card_user_name === '')
            {
                alert("이름을 확인해주세요")
                return;
            }

            if(this.card_user_birth.length !== 6 && this.card_user_birth.length !== 10)
            {
                alert("생년월일/사업자번호를 확인해주세요")
                return;
            }

            // udpate card

            if(this.card_index !== -1)
            {
                this.$store.dispatch(Constant.UPDATE_PARTNER_PAYMENT_CARD, {card_index: this.card_index, card_number: this.card_number, card_pw: this.card_pw, card_ex_month: this.card_ex_month, card_ex_year: this.card_ex_year, card_nick_name: this.card_nick_name, card_user_name: this.card_user_name, card_user_birth: this.card_user_birth, user_id: this.user_id})
                    .then((res) => {
                        // this.$emit('close');
                    })
                    .catch((err) => {
                        alert(err.message)
                    })

            }
            else
            {
                alert("알수없는 에러")
                return;
            }

        },
        close: function()
        {
            // this.$emit('close');
        },
        isNumber: function (value) {
            return /^-?\d+(\.\d+)?$/.test(value);
        }
    },
    watch: {
        cardN1: function()
        {
            if(this.cardN1.length === 4)
            {
                this.$refs.input2.focus();
            }

            // 숫자인지 확인, 4자리
            if(this.cardN1.length > 4)
            {
                // alert("4자리 이상 입력할 수 없습니다.")
                this.cardN1 = this.cardN1.substring(0, 4);
            }
        },
        cardN2: function()
        {
            // 숫자인지 확인, 4자리
            if(this.cardN2.length === 4)
            {
                this.$refs.input3.focus();
            }

            // 숫자인지 확인, 4자리
            if(this.cardN2.length > 4)
            {
                // alert("4자리 이상 입력할 수 없습니다.")
                this.cardN2 = this.cardN2.substring(0, 4);
            }
        },
        cardN3: function()
        {
            // 숫자인지 확인, 4자리
            if(this.cardN3.length === 4)
            {
                this.$refs.input4.focus();
            }

            // 숫자인지 확인, 4자리
            if(this.cardN3.length > 4)
            {
                // alert("4자리 이상 입력할 수 없습니다.")
                this.cardN3 = this.cardN3.substring(0, 4);
            }
        },
        cardN4: function()
        {
            // 숫자인지 확인 3~4자리
            if(this.cardN4.length > 4)
            {
                // alert("4자리 이상 입력할 수 없습니다.")
                this.cardN4 = this.cardN4.substring(0, 4);
            }
        },
        card_ex: function()
        {
            // 숫자인지 확인, 4쟈리 
            // 숫자인지 확인 3~4자리
            if(this.card_ex.length > 4)
            {
                // alert("4자리 이상 입력할 수 없습니다.")
                this.card_ex = this.card_ex.substring(0, 4);
            }
        },
        card_pw: function()
        {
            // 숫자인지 확인, 2자리
            if(this.card_pw.length > 2)
            {
                // alert("2자리 이상 입력할 수 없습니다.")
                this.card_pw = this.card_pw.substring(0, 2);
            }
        },
        card_user_birth: function()
        {
            // 숫자 여부 확인, 10자리 까지가능
            if(this.card_user_birth.length > 10)
            {
                // alert("10자리 이상 입력할 수 없습니다.")
                this.card_user_birth = this.card_user_birth.substring(0, 10);
            }
        }
    }
}
</script>

<style scoped>
    .input {
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        background: #FFFFFF;
        padding-left: 16px;
        padding-right: 16px;
        padding-top: 33px;
        overflow-y: scroll;
    }
    .card-box {
        width: 100%;
        display: flex;
        justify-content: center;
        align-content: center;
    }
    .card-number{
        border-radius: 6px;
        border: 1px solid var(--gray-30-stroke, #E8EAEE);
        background: var(--Gray-00, #FFF);
        width: calc(25% - 18px);
        margin-left: 4px;
        margin-right: 4px;
        padding-left: 4px;
        height: 50px;
    }
    .half-input {
        border-radius: 6px;
        border: 1px solid var(--gray-30-stroke, #E8EAEE);
        background: var(--Gray-00, #FFF);
        width: calc(50% - 25px);
        margin-right: 9px;
        margin-left: 9px;
        height: 50px;
    }
    .full-input {
        border-radius: 6px;
        border: 1px solid var(--gray-30-stroke, #E8EAEE);
        background: var(--Gray-00, #FFF);
        width: calc(100% - 30px);
        height: 50px;
    }
    .bar-style {
        height: 50px; 
        display: flex; 
        justify-content: 
        center; 
        align-items: center;
    }
    .title {
        color: var(--Gray-100, #1E1E1E);
        font-family: "Spoqa Han Sans Neo";
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
        width: 100%;
        margin-left: 25px;
        margin-bottom: 30px;    
    }
    .column{
        display: flex;
        flex-direction: column;
        width: calc(50% - 25px);
    }
    .label{
        color: var(--Gray-100, #1E1E1E);
        font-family: "Spoqa Han Sans Neo";
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        width: 100%;
        margin-left: 25px;
        margin-bottom: 10px;
        margin-top: 30px;
    }
    .button{
        height: 50px;
        flex-shrink: 0;
        border-radius: 6px;
        background: var(--Gray-100, #1E1E1E);
        width:  calc(100% - 25px);
        color: var(--Gray-00, #FFF);
        text-align: center;
        font-family: "Spoqa Han Sans Neo";
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 22px; /* 137.5% */
        margin-top: 60px;
        cursor: pointer;
    }
    .button2{
        height: 50px;
        flex-shrink: 0;
        border: 0;
        background: #FFF;
        width:  calc(100% - 25px);
        color:  #000;
        text-align: center;
        font-family: "Spoqa Han Sans Neo";
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 22px; /* 137.5% */
        margin-top: 10px;
        cursor: pointer; 
    }
</style>


// WEBPACK FOOTER //
// src/pages/card/CardInput.vue